export default __webpack_public_path__ + "static/media/geometric.9775516f.jpg";